import React from "react";
import ConfirmedPatients from "../ConfirmedPatients/ConfirmedPatients";
import useHospitalProviderRole from "./useHospitalProviderRole";

export default function HospitalConfirmedPatients() {
  useHospitalProviderRole();
  return <ConfirmedPatients />;
}
